"use client";
import styles from './styles.module.scss';
import Link from 'next/link';

const ContentItem = props => {
    const {title, copy, cta} = props || {};

    const renderTitle = () => {
        if(!title) return null;
        return (
            <h4 className={styles.contentBlock__title}>
                {title}
            </h4>
        );
    }

    const renderCopy = () => {
        if(!copy) return null;
        return(
            <div className={styles.contentBlock__copy} dangerouslySetInnerHTML={{__html: copy || ``}}/>
        );
    }

    const renderCta = () => {
        if(!cta?.title) return null;

        return(
            <Link href={cta?.url || `#`}  className={`${styles.contentBlock__cta} cta_arrow`}>
                {cta?.title}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#D41050"/>
                </svg>
            </Link>
        );
    }

    return(
        <div className={styles.contentBlock__content}>
            {renderTitle()}
            {renderCopy()}
            {renderCta()}
        </div>
    );
}

export default ContentItem;